import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

type Props = {
  onActionEditar: (Id: number | null, openState: boolean) => void;
  onActionDeletar: (Id: number | null, openState: boolean) => void;
  onActionCopiar: (IdAuditoria: number | null, openState: boolean) => void;
};

export const GenerateProcessoAuditoriaAuditoriasColumns = ({
  onActionEditar,
  onActionCopiar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "Processo",
      filterable: false,
      headerName: "Processo",
      flex: 1,
      minWidth: 180,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "RequisitoNormativo",
      filterable: false,
      headerName: "Requisito Normativo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "FuncionarioNome",
      filterable: false,
      headerName: "Responsável",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "LocalNome",
      filterable: false,
      headerName: "Local",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Data",
      filterable: false,
      headerName: "Data",
      flex: 1,
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>
              {params.value && dayjs(params.value).format("DD/MM/YYYY")}
            </span>
          </div>
        );
      },
    },
    {
      field: "Horario",
      filterable: false,
      headerName: "Horário",
      flex: 1,
      maxWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "IdProcesso",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      width: 120,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon
                nameIcon="EditRounded"
                size={25}
                className="dark:text-white text-primary-green"
              />
            </IconButton>
            <IconButton onClick={() => onActionCopiar(params.value, true)}>
              <DynamicIcon
                nameIcon="ContentCopyRounded"
                size={22}
                className="dark:text-white text-gray-500"
              />
            </IconButton>
            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={25}
                className="text-red-500"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
